"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_NAV_LAYOUT_MODE = exports.NAV_LAYOUT_MODES = void 0;
exports.isNavLayoutMode = isNavLayoutMode;
exports.navLayoutToDb = navLayoutToDb;
exports.navLayoutFromDb = navLayoutFromDb;
/** Τρόπος εμφάνισης κύριας πλοήγησης (web) */
exports.NAV_LAYOUT_MODES = ['top', 'sidebar', 'both'];
exports.DEFAULT_NAV_LAYOUT_MODE = 'sidebar';
function isNavLayoutMode(value) {
    return exports.NAV_LAYOUT_MODES.includes(value);
}
function navLayoutToDb(mode) {
    switch (mode) {
        case 'top':
            return 'TOP';
        case 'sidebar':
            return 'SIDEBAR';
        case 'both':
            return 'BOTH';
    }
}
function navLayoutFromDb(mode) {
    switch (mode) {
        case 'TOP':
            return 'top';
        case 'SIDEBAR':
            return 'sidebar';
        case 'BOTH':
            return 'both';
        default:
            return exports.DEFAULT_NAV_LAYOUT_MODE;
    }
}
